import { render, staticRenderFns } from "./ProjectAtRiskList.vue?vue&type=template&id=fe34793a&scoped=true&"
import script from "./ProjectAtRiskList.vue?vue&type=script&lang=js&"
export * from "./ProjectAtRiskList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAtRiskList.vue?vue&type=style&index=0&id=fe34793a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe34793a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VList,VListItem,VListItemSubtitle,VListItemTitle,VSpacer})
